<div
  [ngStyle]="{ background: 'url(assets/images/MADB-BANNER-6.jpg)' }"
  class="content-header"
  id="grad"
>
  <span class="header-title">Qualifications</span>
</div>
<app-form
  class="new-qualification-form"
  [sections]="sections"
  [data]="qualification"
  [mode]="mode"
  cancel="qualifications"
  (submitted)="submitForm($event)"
></app-form>
